import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Container } from "react-bootstrap";
import TourSlider from "./TourSlider";
import {
  activityStart,
  activityEnd,
} from "../../redux/slices/trackActivitySlice";
import usePageTracking from "../../hooks/usePageTracking";

export default function TourPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(activityStart({ page_name: "TOUR", platform: "web" }));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(activityEnd({ page_name: "TOUR" }));
    };
  }, [dispatch]);

  usePageTracking("TOUR");

  // Token validation is handled by ProtectedRoute wrapper in AppRoutes.js
  // No need for redundant checks here

  return (
    <>
      <section className="heroBanner_wrap only-text inner-banner">
        <div className="heroBanner">
          {/* <Container> */}
          <div className="heroBanner__innrer">
            <div className="heroBanner__content">
              <h1
                className="heroBanner__content-title"
                style={{ display: "none" }}
              >
                Plan Your Nursing Career with Confidence
              </h1>
              <h2 className="heroBanner__content-title">
                Plan Your Nursing Career with Confidence
              </h2>
              <div className="heroBanner__content-description pb-0">
                Compare nursing salaries by city and state, adjusted for cost of
                living. Discover <br />
                where your skills are valued most using trusted BLS data.
              </div>
            </div>
          </div>
          {/* </Container> */}
        </div>
      </section>

      {/*  <div className="breadcrumbs pb-0">
        <Container>
          <nav aria-label="Breadcrumb">
            <ul className="breadcrumb-list">
              <li className="breadcrumb-item">
                <a href="/">
                  <span>Home</span>
                </a>
              </li>

              <li className="breadcrumb-sep" aria-hidden="true">/</li>
              
              <li className="breadcrumb-item">
                <a href="/">
                  <span>Login</span>
                </a>
              </li>

              <li className="breadcrumb-sep" aria-hidden="true">/</li>

              <li className="breadcrumb-item current" aria-current="page">
                <span>Registration Steps</span>
              </li>
            </ul>
          </nav>
        </Container>
      </div> */}

      <section className="registration-content tour-content">
        {/* <Container> */}
        <div className="registration-form">
          <TourSlider
            show={true}
            onSkip={() => navigate("/dashboard")}
            onComplete={() => navigate("/dashboard")}
          />
        </div>
        {/* </Container> */}
      </section>
    </>
  );
}
